export const dataLibM = [{
  word: 'mouton',
  partOfSpeech: 'N',
  definition: ['sheep'],
  egSentenceKw: 'Tan lontan savann Vyé Fò té benyen mouton.',
  egSentenceEn: 'Long ago the field in Vieux Fort was full of sheep.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mouton]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mwa',
  partOfSpeech: 'N',
  definition: ['month'],
  egSentenceKw: 'Yo kay wèsté dé mwa lòt péyi.',
  egSentenceEn: 'They are going to stay two months overseas.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mois]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mouchwè',
  partOfSpeech: 'N',
  definition: ['kerchief', 'scarf'],
  egSentenceKw: 'Sé pou tèt ou mawé èk mouchwè pou\'w té dansé kòdwil.',
  egSentenceEn: 'Your head must be tied with a kerchief for you to danse the quadrille.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mouchoir]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mont',
  partOfSpeech: 'N',
  definition: ['clock', 'watch'],
  egSentenceKw: 'I ni on mont nèf.',
  egSentenceEn: 'He has a new watch.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. montre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mété',
  partOfSpeech: 'V',
  definition: ['to put'],
  egSentenceKw: 'Mété bwèt-la asou tab-la.',
  egSentenceEn: 'Put the box on the table.',
  synonym: ['ladjé', 'pitjé', 'pwan'],
  antonym: ['tiwé'],
  etymology: '[< Fr. mettre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'manman',
  partOfSpeech: 'N',
  definition: ['mother'],
  egSentenceKw: 'Kouman manman\'w?',
  egSentenceEn: 'How\'s your mother?',
  synonym: ['bidim', 'matenmm'],
  antonym: [null],
  etymology: '[< Fr. maman]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mwen',
  partOfSpeech: 'PRO',
  definition: ['I', 'me', 'my', 'mine'],
  egSentenceKw: 'Mwen pèd tout lajan mwen.',
  egSentenceEn: 'I lost all my money.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. moi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'misyé',
  partOfSpeech: 'TITLE',
  definition: ['Mr'],
  egSentenceKw: 'Misyé Ambrose ka twavay atjòlman.',
  egSentenceEn: 'Mr. Ambrose is working now.',
  synonym: ['nonm'],
  antonym: [null],
  etymology: '[< Fr. monsieur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'misyé',
  partOfSpeech: 'TITLE',
  definition: ['sir'],
  egSentenceKw: 'Ki sa ou vlé, misyé?',
  egSentenceEn: 'What do you want, sir?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. monsieur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mannwa',
  partOfSpeech: 'N',
  definition: ['warship'],
  egSentenceKw: 'La ni an mannwa an lawad-la',
  egSentenceEn: 'There is a warship in the harbour.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. man-of-war]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'misték',
  partOfSpeech: 'N',
  definition: ['mistake'],
  egSentenceKw: 'Nou fè an chay misték.',
  egSentenceEn: 'We made many mistakes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. mistake]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mitin',
  partOfSpeech: 'N',
  definition: ['meeting'],
  egSentenceKw: 'Nou ka tjenn mitin nou òswè-a.',
  egSentenceEn: 'We are having our meeting tonight.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. meeting]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'motoka',
  partOfSpeech: 'N',
  definition: ['automobile', 'car'],
  egSentenceKw: 'I genyen on motoka nèf.',
  egSentenceEn: 'He bought a new car.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. motor car]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'manjé',
  partOfSpeech: 'V',
  definition: ['to eat'],
  egSentenceKw: 'Yo pa manjé pwéson-an.',
  egSentenceEn: 'They didn\'t eat the fish.',
  synonym: ['dévowé'],
  antonym: [null],
  etymology: '[< Fr. manger]',
  dialect: '🇱🇨',
  variant: ['manhé'],
}, {
  word: 'mété',
  partOfSpeech: 'V',
  definition: ['to begin to'],
  egSentenceKw: 'Yo mété kouwi!',
  egSentenceEn: 'They began to run!',
  synonym: ['koumansé', 'pitjé', 'pwan'],
  antonym: [null],
  etymology: '[< Fr. mettre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'malfini',
  partOfSpeech: 'N',
  definition: ['chicken hawk'],
  egSentenceKw: 'Malfini ka manjé ti poul.',
  egSentenceEn: 'Chicken hawks eat small chickens.',
  synonym: ['gwigwi poulé'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mèl',
  partOfSpeech: 'N',
  definition: ['blackbird'],
  egSentenceKw: 'Mèl kontan manjé mi.',
  egSentenceEn: 'Blackbirds like to eat corn.',
  synonym: ['gwigwi poulé'],
  antonym: [null],
  etymology: '[< Fr. merle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mwennson',
  partOfSpeech: 'N',
  definition: ['a type of small bird'],
  egSentenceKw: 'Bèk mwennson-an ka sanm bèk jako.',
  egSentenceEn: 'The mwennson\'s beak resembles a parrot\'s.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'manmzèl',
  partOfSpeech: 'N',
  definition: ['unmarried young woman'],
  egSentenceKw: 'Sa sé on bèl manmzèl ki ka vann an magazen-an.',
  egSentenceEn: 'That is a pretty young woman who is selling in the store.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mademoiselle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'manmay',
  partOfSpeech: 'N',
  definition: ['child'],
  egSentenceKw: 'Tout sé manmay-la ni wim.',
  egSentenceEn: 'All of the children have colds.',
  synonym: ['ti manmay', 'zanfan'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mé',
  partOfSpeech: 'CONJ',
  definition: ['but'],
  egSentenceKw: 'Nou té la mé nou pa wè\'y.',
  egSentenceEn: 'We were there but we didn\'t see him.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mais]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'moun',
  partOfSpeech: 'N',
  definition: ['person'],
  egSentenceKw: 'Moun sala sé on Fwansé.',
  egSentenceEn: 'That person is a Frenchman.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. monde]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'maché',
  partOfSpeech: 'V',
  definition: ['to walk'],
  egSentenceKw: 'I té tèlman sou i pa té sa menm maché.',
  egSentenceEn: 'He was so drunk he couldn\'t even walk.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. marcher]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mango',
  partOfSpeech: 'N',
  definition: ['mango (Mangifera indica)'],
  egSentenceKw: 'Yo ka vann tout sòt kalté mango.',
  egSentenceEn: 'They sell all kinds of mangos.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Tamil. mankay]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'madanm',
  partOfSpeech: 'N',
  definition: ['lady', 'woman'],
  egSentenceKw: 'Madanm sala ka vann pen.',
  egSentenceEn: 'That woman sells bread.',
  synonym: [null],
  antonym: ['mawi'],
  etymology: '[< Fr. madame]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'madanm',
  partOfSpeech: 'N',
  definition: ['wife'],
  egSentenceKw: 'Madanm mwen kay vini denmen.',
  egSentenceEn: 'My wife is coming tomorrow.',
  synonym: [null],
  antonym: ['mawi'],
  etymology: '[< Fr. madame]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'madanm',
  partOfSpeech: 'Title',
  definition: ['Mrs.', 'Mistress', '(used with surname)'],
  egSentenceKw: 'Madanm Ambrose tonbé malad.',
  egSentenceEn: 'Mrs. Ambrose fell sick.',
  synonym: ['man'],
  antonym: [null],
  etymology: '[< Fr. madame]',
  dialect: '🇱🇨',
  variant: ['mèyè'],
}, {
  word: 'mawi',
  partOfSpeech: 'Title',
  definition: ['husband'],
  egSentenceKw: 'Mawi\'y sé on mason.',
  egSentenceEn: 'Her husband is a mason.',
  synonym: [null],
  antonym: ['madanm'],
  etymology: '[< Fr. mari]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'misyé',
  partOfSpeech: 'N',
  definition: ['man'],
  egSentenceKw: 'Misyé sala kay vini denmen.',
  egSentenceEn: 'That man will come tomorrow.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. monsieur]',
  dialect: '🇱🇨',
  variant: [null],
},
];
